import { tr } from './locales/tr';
/**
 * Sunucu YOLU → alan etiketinin anahtarı.
 *
 * Etkinlik yazma yüzeylerinin tamamı (oluşturma sihirbazı + panel künye formu)
 * ve kurum oluşturma formu kapsanır; `venue.*` yolları alt nesnenin kendi
 * adlarını taşır.
 *
 * `name` / `contactEmail` KURUM formundan gelir (elle test 3 · md. 5): kullanıcı
 * iletişim e-postasına `test` yazdı, ekran yalnız "Girdiğin bilgilerde hata var."
 * dedi. Yol etiketi bilinmediği sürece cümle ÜRETİLMEZ, yani bu iki satır
 * olmadan hata alan altına da yazılamıyordu.
 */
const FIELD_LABEL_KEYS = {
    name: 'fields.name',
    contactEmail: 'fields.contactEmail',
    title: 'fields.eventTitle',
    summary: 'fields.eventSummary',
    description: 'fields.eventDescription',
    format: 'fields.eventFormat',
    startsAt: 'fields.eventStartsAt',
    endsAt: 'fields.eventEndsAt',
    timezone: 'fields.eventTimezone',
    onlineUrl: 'fields.eventOnlineUrl',
    capacity: 'fields.eventCapacity',
    websiteUrl: 'fields.eventWebsiteUrl',
    tagIds: 'fields.eventTagIds',
    'venue.name': 'fields.venueName',
    'venue.addressLine': 'fields.venueAddressLine',
    'venue.cityCode': 'fields.venueCity',
    'venue.countryCode': 'fields.venueCountry',
    // Harita (bölüm 11 madde 1): yayında konum yoksa "Haritada konumu seç" konum kutusunun altına.
    'venue.geo': 'fields.venueGeo',
    // Organizatör sayfası şehri (14.10.2026, QA P2-1): serbest metin, 80 karakter sınırı alan altına yazılır.
    city: 'fields.city',
    // Panel şifresi (kullanıcı kararı 02.09.2026 · §2) — uzunluk hatası alan altına yazılır.
    currentPassword: 'fields.currentPassword',
    newPassword: 'fields.newPassword',
    // Satış başvurusu formu (T5 · W1): istemci doğrulaması da AYNI yolları üretir.
    companyName: 'fields.salesCompanyName',
    eventType: 'fields.salesEventType',
    estimatedAttendees: 'fields.salesEstimatedAttendees',
    estimatedDate: 'fields.salesEstimatedDate',
    contactName: 'fields.salesContactName',
    email: 'fields.salesEmail',
    phone: 'fields.salesPhone',
    note: 'fields.salesNote',
    noticeAcknowledged: 'fields.salesNoticeAcknowledged',
    // Kurum talebi formu (B-21): etiket yoksa "zorunlu" cümlesi kurulmuyor, paketsiz
    // gönderim sessiz kalıyordu. Formun kendi alan etiketleri kullanılır.
    topic: 'orgRequest.fieldTopic',
    creditPackage: 'orgRequest.fieldPackage',
    // Referans kodu (Story 2): biçim hatası alanın altına yazılır, geçerlilik hiç söylenmez.
    referralCode: 'orgRequest.fieldReferralCode',
    // Panel ve web formlarının eski borcu (14.10.2026): `{field}` isteyen sunucu
    // reddi alan altına yazılsın. `reason`/`reference` birden çok diyalogda geçer;
    // görünen etiketler ölçüldü ("Gerekçe", "Gerekçe ya da not", "Sonlandırma
    // gerekçesi" · "Referans", "Sözleşme ya da teklif no") ve ortak etiket hepsine
    // doğru düştüğü için yol başına tek etiket yeter. `token` yolu panel kurulum
    // kodundan başka kart değişimi kısa kodunu, davet ve dışa aktarım jetonunu da
    // taşır; bu yüzden etiketi dar ("Davet kodu") değil nötr ("Kod").
    token: 'fields.token',
    displayName: 'fields.displayName',
    role: 'fields.role',
    startDay: 'fields.startDay',
    endDay: 'fields.endDay',
    reference: 'fields.reference',
    reason: 'fields.reason',
    purchaseDay: 'fields.purchaseDay',
    salesInquiryId: 'fields.salesInquiry',
    ownerEmail: 'fields.ownerEmail',
    amount: 'fields.amount',
    linkedinUrl: 'fields.linkedinUrl',
    xUrl: 'fields.xUrl',
    githubUrl: 'fields.githubUrl',
    code: 'fields.verificationCode',
    password: 'fields.password',
    // Organizatör duyurusu yazma formu (Story 3): uzunluk ve bağlantı tavanı alan altına yazılır.
    subject: 'fields.announcementSubject',
    body: 'fields.announcementBody',
    // Mobil yazma ekranı (Story 12): sunucunun kanal reddi kanal grubunun altına yazılır.
    channels: 'fields.announcementChannels',
    // Belge ve anket (Story 2-3): sunucu reddi formun kendi alan etiketiyle alan altına yazılır.
    // Üst düzey `text`/`options` yalnız anket sorusu şemasında geçer (cevap ve hatırlatma iç içedir).
    signerName: 'eventSurvey.manage.signerName',
    signerTitle: 'eventSurvey.manage.signerTitle',
    text: 'eventSurvey.manage.questionText',
    options: 'eventSurvey.manage.options',
    // Katılımcı anketi (Story 4): istemci `answers.<sıra>.<alan>` yolunu soruya eşleyip
    // `answer` yoluna indirger (dinamik sıra sözlüğe yazılamaz); cümle o sorunun altında.
    answer: 'fields.surveyAnswer',
};
/** Sözlükteki kural kümesi — bilinmeyen kural EKRANA ÇIKMAZ. */
const KNOWN_RULES = tr.validation;
function toText(one) {
    const template = KNOWN_RULES[one.rule];
    if (template === undefined)
        return null;
    const fieldKey = FIELD_LABEL_KEYS[one.path] ?? null;
    // Cümle alan adını İSTİYORSA ve etiket bilinmiyorsa satır üretilmez.
    if (fieldKey === null && template.includes('{field}'))
        return null;
    const params = {};
    for (const [key, value] of Object.entries(one.params ?? {})) {
        params[key] = typeof value === 'boolean' ? String(value) : value;
    }
    return {
        path: one.path,
        ruleKey: `validation.${one.rule}`,
        fieldKey,
        params,
    };
}
/**
 * Yanıttaki alan hatalarını cümleye çevrilebilir satırlara indirger.
 * Aynı alan birden çok kural kırdıysa YALNIZ İLKİ gösterilir (gürültü olmasın).
 */
export function fieldErrorTexts(error) {
    const seen = new Set();
    const out = [];
    for (const one of error?.fieldErrors ?? []) {
        if (seen.has(one.path))
            continue;
        const text = toText(one);
        if (text === null)
            continue;
        seen.add(one.path);
        out.push(text);
    }
    return out;
}
export function splitFieldErrorTexts(error, inlinePaths) {
    const texts = fieldErrorTexts(error);
    const inline = new Map();
    const rest = [];
    for (const text of texts) {
        if (inlinePaths.includes(text.path))
            inline.set(text.path, text);
        else
            rest.push(text);
    }
    // Çevrilemeyen kural (sözlükte yok) `texts` dışında kalır; o hâlde de genel
    // cümle gerekir — bu yüzden karşılaştırma HAM yol kümesiyle yapılır.
    const reported = new Set((error?.fieldErrors ?? []).map((one) => one.path));
    const fullyInline = reported.size > 0 && rest.length === 0 && inline.size === reported.size;
    return { inline, rest, fullyInline };
}
/**
 * Satırın CÜMLESİ: web kiti (`packages/ui` `useFormErrors`) ve mobil kanca
 * AYNI işlevi çağırır. Joi bağlamının sayıları (`limit`) YEREL BİÇİMLE yazılır
 * (T5 QA P3-1): "en fazla 100.000 olabilir", EN'de "100,000". Metin
 * parametreleri aynen geçer. Bu yol yıl taşıyan bir alanı kapsamaz
 * (`FIELD_LABEL_KEYS`te yıl yok, `field-error-text.spec` bunu dondurur);
 * yıl alanı eklenirse sayısı burada gruplanırdı.
 */
export function fieldErrorSentence(t, item) {
    const params = localizedNumberParams(t, item.params);
    if (item.fieldKey !== null)
        params.field = t.t(item.fieldKey);
    return t.t(item.ruleKey, params);
}
/** İstemcinin kendi kurduğu kural satırının cümlesi (sihirbazın `DraftIssue`ı), sayılar yerel biçimle. */
export function issueSentence(t, issue) {
    return t.t(issue.messageKey, localizedNumberParams(t, issue.params));
}
/**
 * Cümle parametrelerinin SAYILARI yerel biçimle (tech-lead 22.10.2026). Sunucu
 * hatası (`fieldErrorSentence`) ile istemcinin kendi kurduğu alan hatası
 * (sihirbazın `draftIssues`ı, formun sınır denetimi) AYNI biçimi yazar: ipucu
 * "1.000" derken hata "1000" demez. Yıl taşıyan parametreye uygulanmaz.
 */
export function localizedNumberParams(t, params) {
    const out = {};
    for (const [key, value] of Object.entries(params ?? {})) {
        out[key] = typeof value === 'number' ? t.formatNumber(value) : value;
    }
    return out;
}
/** Yol → alan etiketi eşlemesinin yolları (spec için; yıl alanı kapısı). */
export const FIELD_ERROR_LABELLED_PATHS = Object.keys(FIELD_LABEL_KEYS);
//# sourceMappingURL=field-error-text.js.map